import { useState } from "@faire/web--source/ui/hooks/useState";
import { useCallback } from "react";

import { IssueId, SelfServeNode } from "../types";

interface IUseNodesConditionalVisibilityState {
  nodesConditionalVisibility: Readonly<Record<IssueId, boolean>>;
  updateNodeVisibility: (node: SelfServeNode, isVisible: boolean) => void;
}

export const useNodesConditionalVisibilityState =
  (): IUseNodesConditionalVisibilityState => {
    const [nodesConditionalVisibility, setNodesConditionalVisibility] =
      useState<Record<IssueId, boolean>>({});

    const updateNodeVisibility = useCallback(
      (node: SelfServeNode, isVisible: boolean) => {
        setNodesConditionalVisibility((values) => ({
          ...values,
          [node.id]: isVisible,
        }));
      },
      []
    );

    return {
      nodesConditionalVisibility,
      updateNodeVisibility,
    };
  };
